import { Vehicle } from '@esportal/portal-service';
import {
	AspectRatioContainer,
	AspectRatioWrapper,
	BreakpointWrapper,
	Container,
	ContainerPadding,
	CTA,
	Image,
	Richtext,
	Text,
	TextAlignment,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { Add } from '@volkswagen-onehub/icons-core';
import { default as React, useEffect, useState } from 'react';
import { useDisclaimers } from '../../../context/disclaimers-context';
import { PortalContext } from '../../../context/portal-context';
import { Environment } from '../../../enviroment';
import { actionRedirect } from '../../../helpers/common-helpers';
import { formatOwnership } from '../../../tracking/tracking-helper';
import { useTrackingManager } from '../../../tracking/use-tracking-manager';
import { Alert, AlertType, CombinedAlert } from '../alerts-type';

import { VouchersCarInfo } from '../../benefits/vouchers/componentes/vouchers-description';
import { alertsData } from '../data/alerts-data';
import {
	CardContainer,
	ContainerEntregaIdeal,
	ContentWrapper,
	CTAContainer,
	CTAStyled,
	DescriptionTextContainer,
	ImageWrapper,
	StyledReferenceBadge,
	TextWrapper,
	VideoStyled,
} from '../ui/alert-card-styles';

export const AlertCard = ({
	alert,
	alertPosition,
	numberOfAlerts,
	setIsIdWeChargePopUpVisible,
	setIsPromotionPopupVisible,
	setAlertTypePromotion,
}: {
	alert: CombinedAlert;
	alertPosition: number;
	numberOfAlerts: number;
	className: string;
	setIsIdWeChargePopUpVisible: React.Dispatch<React.SetStateAction<boolean>>;
	setIsPromotionPopupVisible: React.Dispatch<React.SetStateAction<boolean>>;
	setAlertTypePromotion: (type: AlertType) => void;
}): React.ReactElement => {
	const { navigationService, userInteractionService } = React.useContext(PortalContext);
	const trackingManager = useTrackingManager();

	const { alertType, voucher } = alert;
	const vehicle: Vehicle | undefined = 'vehicle' in alert ? alert.vehicle : undefined;
	const vehicleName = vehicle?.vgedModelGroup ?? '';

	const handleClickAlert = async (vehicle: Vehicle | undefined, alertType: AlertType) => {
		trackingManager.trackClubVWButtonClick(
			'Alerts',
			{ contentId: `Alert ${alertType}` },
			{ vehicle: formatOwnership(vehicle ? [vehicle] : []) },
		);

		if (alertType === AlertType.Mantenimiento && vehicle) {
			const environmentPath = Environment.getInstance().maintenancePage as string;
			const search = window.location.search;
			const target = navigationService.navigateTo(environmentPath, {});

			if (target) {
				target.push();
				const href = target.createHref();
				addParamToUrl(href, vehicle.name, search);
			}
		}

		if (alertType === AlertType.PreITV && vehicle) {
			actionRedirect(userInteractionService, 'action:es-cca-loader--open_layer');
		}

		if (alertType === AlertType.EntregaIdeal && voucher?.card.cta?.src) {
			window.location.href = voucher.card.cta?.src;
		}

		if (alertType === AlertType.OneToOneID && voucher?.card.cta?.src) {
			window.open(voucher?.card.cta?.src, '_blank');
		}

		if (alertType === AlertType.OneToOnePolo && voucher?.card.cta?.src) {
			window.open(voucher?.card.cta?.src, '_blank');
		}

		if (alertType === AlertType.Touran) {
			window.open('https://www.volkswagen.es/es/modelos/touran.html#ofertas');
		}

		if (alertType === AlertType.GolfGTI) {
			const environmentPath = Environment.getInstance().gti50 as string;
			const target = navigationService.navigateTo(environmentPath, {});
			if (target) {
				target.push();
				const currentUrl = window.location.href;
				const quizzUrl = currentUrl + '/__app/quiz.app';
				window.location.href = quizzUrl;
			} else {
				console.log('detail page not created');
			}
		}

		if (alertType === AlertType.IDWeCharge) {
			setIsIdWeChargePopUpVisible(true);
		}

		if (
			alertType === AlertType.Masters26_Open ||
			alertType === AlertType.Masters26_Enrolled ||
			alertType === AlertType.Masters26_NoWinner
		) {
			const environmentPath = Environment.getInstance().mastersCarretera as string;
			const target = navigationService.navigateTo(environmentPath, {});
			if (target) {
				target.push();
			}
		}
		if (alertType === AlertType.Masters26_Winner) {
			setAlertTypePromotion(AlertType.Masters26_Winner);
			setIsPromotionPopupVisible(true);
		}

		if (alertType === AlertType.LaLiga26_Open) {
			setAlertTypePromotion(AlertType.LaLiga26_Open);
			setIsPromotionPopupVisible(true);
		}

		if (alertType === AlertType.LaLiga26_Enrolled || alertType === AlertType.LaLiga26_NoWinner) {
			const environmentPath = Environment.getInstance().laLiga as string;
			const target = navigationService.navigateTo(environmentPath, {});
			if (target) {
				target.push();
			}
		}

		if (alertType === AlertType.ElClasico26_Open) {
			setAlertTypePromotion(AlertType.ElClasico26_Open);
			setIsPromotionPopupVisible(true);
		}

		if (alertType === AlertType.ElClasico26_Enrolled || alertType === AlertType.ElClasico26_NoWinner) {
			const environmentPath = Environment.getInstance().laLiga as string;
			const target = navigationService.navigateTo(environmentPath, {});
			if (target) {
				target.push();
			}
		}

		// GTI Day 2026
		if (alertType === AlertType.GTIDay26_Open) {
			setAlertTypePromotion(AlertType.GTIDay26_Open);
			setIsPromotionPopupVisible(true);
		}
		if (alertType === AlertType.GTIDay26_Enrolled) {
			window.open('https://gti50fest.com/', '_blank');
		}

		// GTI Day VIP 2026
		if (alertType === AlertType.GTIDayVIP26_Open) {
			setAlertTypePromotion(AlertType.GTIDayVIP26_Open);
			setIsPromotionPopupVisible(true);
		}
		if (alertType === AlertType.GTIDayVIP26_Enrolled || alertType === AlertType.GTIDayVIP26_Full) {
			window.open('https://gti50fest.com/', '_blank');
		}

		// Vouchers detail landing page
		if (
			alertType === AlertType.IDWeChargePostPedido ||
			alertType == AlertType.EscuelaSeguridadVW ||
			alertType == AlertType.AlertaIncapto
		) {
			const environmentPath = Environment.getInstance().vouchersDetailPageId as string;
			const search = window.location.search;
			const target = navigationService.navigateTo(environmentPath, {});
			if (target && voucher) {
				target.push();
				const href = target.createHref();
				const newSearchParams = new URLSearchParams(search);
				newSearchParams.append('voucher-id', voucher?.id);
				window.history.replaceState(null, '', href + `?${newSearchParams.toString()}`);
			} else {
				console.log('detail page not created');
			}
		}
	};

	const addParamToUrl = (href: string, param: string, search: string) => {
		const newSearchParams = new URLSearchParams(search);
		newSearchParams.append('vin', param);
		window.history.replaceState(null, '', href + `?${newSearchParams.toString()}`);
	};

	const personalizeAlertText = (text?: string): string => {
		if (!text) return '';

		if (!vehicleName) {
			return text.replace('[modelo]', 'Volkswagen');
		}

		return text.replace('[modelo]', vehicleName);
	};

	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => setWindowWidth(window.innerWidth);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const renderAlertMedia = (alert: Alert | undefined) => {
		if (alert?.videoSrc) {
			return <VideoStyled src={alert?.videoSrc} autoPlay playsInline muted loop />;
		}

		let mediaSrc = alert?.imageSrc;
		if (alertType === AlertType.Mantenimiento && vehicle?.mediaAssets?.Front_Left) {
			mediaSrc = vehicle.mediaAssets.Front_Left;
		}

		return (
			<Image
				data-testid="image-alert"
				src={mediaSrc}
				objectFit="cover"
				alt={vehicle?.vgedModelGroup || 'Alert image'}
				style={{ borderRadius: '16px' }}
			/>
		);
	};

	const currentAlertType = alertsData.find((type) => type.type === alertType);
	const { findBadge } = useDisclaimers();
	const disclaimerText = alert.voucher?.legalText ?? currentAlertType?.disclaimerText; // priorizamos el disclaimer del voucher si existe, sino usamos el del alert (hardcodeado)
	const badge = disclaimerText ? findBadge(disclaimerText) : undefined;

	const renderVehicleInfo = () =>
		vehicleName ? (
			<VouchersCarInfo className="vouchers-car-info" style={{ zIndex: 1 }}>
				<Text appearance={TokenTextAppearance.label100} bold>
					{vehicleName}
				</Text>
			</VouchersCarInfo>
		) : null;

	const getAspectRatio = (numberOfAlerts: number, alertPosition: number, windowWidth: number) => {
		if (windowWidth < 960) {
			return '16:9';
		}

		if (numberOfAlerts === 1) {
			return '2:1';
		}

		if (numberOfAlerts > 2 && alertPosition === 0) {
			return '2:1';
		}

		if ((numberOfAlerts > 2 && alertPosition === 1) || (numberOfAlerts === 2 && alertPosition === 0)) {
			return '2:1';
		}

		if ((numberOfAlerts > 2 && alertPosition === 2) || (numberOfAlerts === 2 && alertPosition === 1)) {
			return '3:2';
		}

		return '16:9';
	};

	return (
		<>
			{currentAlertType && (
				<>
					<CardContainer
						className="alert-card-container"
						alertType={alertType}
						alertPosition={alertPosition}
						numberOfAlerts={numberOfAlerts}
						vehicleInterior={vehicle?.mediaAssets?.Interior_Lhd_Center || vehicle?.mediaAssets?.Interior_Side || ''}
						onClick={() => handleClickAlert(vehicle, alertType)}
						windowWidth={windowWidth}
					>
						{(windowWidth >= 960 && numberOfAlerts > 2 && alertPosition === 0) ||
						(windowWidth >= 960 && numberOfAlerts === 1) ? (
							<>
								{alertType === AlertType.EntregaIdeal ? (
									<ContainerEntregaIdeal
										data-testid="entrega-ideal"
										alertType={alertType}
										alertPosition={alertPosition}
										numberOfAlerts={numberOfAlerts}
										windowWidth={windowWidth}
										vehicleInterior={
											vehicle?.mediaAssets?.Interior_Lhd_Center ?? vehicle?.mediaAssets?.Interior_Side ?? ''
										}
										style={{ borderRadius: '16px' }}
									/>
								) : (
									<ImageWrapper>
										<AspectRatioWrapper>
											<AspectRatioContainer ratio={getAspectRatio(numberOfAlerts, alertPosition, windowWidth)}>
												{renderAlertMedia(currentAlertType)}
											</AspectRatioContainer>
										</AspectRatioWrapper>
										{renderVehicleInfo()}
									</ImageWrapper>
								)}

								<ContentWrapper>
									<TextWrapper>
										<Container wrap="always">
											<BreakpointWrapper>
												<Container padding={{ bottom: ContainerPadding.static150 }} data-testid="alert-card">
													<Text appearance={TokenTextAppearance.headline300}>
														<Richtext
															dangerouslyParseRawHTML
															markdown={personalizeAlertText(currentAlertType?.title)}
														/>
													</Text>
												</Container>

												<Text appearance={TokenTextAppearance.copy200}>
													<DescriptionTextContainer className="description-text-container">
														<Richtext
															dangerouslyParseRawHTML
															markdown={personalizeAlertText(currentAlertType?.description)}
														/>
														{badge && (
															<>
																{' '}
																<StyledReferenceBadge>{badge.replace(/\.$/, '')}</StyledReferenceBadge>
															</>
														)}
													</DescriptionTextContainer>
												</Text>
											</BreakpointWrapper>
										</Container>
									</TextWrapper>
									{alertType !== AlertType.VWBook26_Agotado && alertType !== AlertType.VWBook26_Participado && (
										<CTAContainer numberOfAlerts={numberOfAlerts} alertPosition={alertPosition}>
											<Container horizontalAlign={'flex-end'} stretchContent>
												<Text textAlign={TextAlignment.end}>
													<CTAStyled className="cta-styled" alertType={alertType}>
														<CTA tag="button" emphasis={'nbab'} icon={<Add variant="default" aria-hidden />} />
													</CTAStyled>
												</Text>
											</Container>
										</CTAContainer>
									)}
								</ContentWrapper>
							</>
						) : (
							<>
								<ContentWrapper>
									{alertType === AlertType.EntregaIdeal ? (
										<ContainerEntregaIdeal
											data-testid="entrega-ideal"
											alertType={alertType}
											alertPosition={alertPosition}
											numberOfAlerts={numberOfAlerts}
											windowWidth={windowWidth}
											vehicleInterior={
												vehicle?.mediaAssets?.Interior_Lhd_Center ?? vehicle?.mediaAssets?.Interior_Side ?? ''
											}
											style={{ borderRadius: '16px' }}
										/>
									) : (
										<>
											<AspectRatioContainer ratio={getAspectRatio(numberOfAlerts, alertPosition, windowWidth)}>
												{renderAlertMedia(currentAlertType)}
											</AspectRatioContainer>
											{renderVehicleInfo()}
										</>
									)}

									<Container wrap="always" padding={ContainerPadding.dynamic0100}>
										<BreakpointWrapper>
											<Container padding={{ bottom: ContainerPadding.static150 }} data-testid="alert-card">
												<Text appearance={TokenTextAppearance.headline300}>
													<Richtext dangerouslyParseRawHTML markdown={personalizeAlertText(currentAlertType?.title)} />
												</Text>
											</Container>

											<Text appearance={TokenTextAppearance.copy200}>
												<DescriptionTextContainer className="description-text-container">
													<Richtext
														dangerouslyParseRawHTML
														markdown={personalizeAlertText(currentAlertType?.description)}
													/>{' '}
													{badge && <StyledReferenceBadge>{badge.replace(/\.$/, '')}</StyledReferenceBadge>}
												</DescriptionTextContainer>
											</Text>
										</BreakpointWrapper>
									</Container>
								</ContentWrapper>
								{alertType !== AlertType.VWBook26_Agotado && alertType !== AlertType.VWBook26_Participado && (
									<CTAContainer numberOfAlerts={numberOfAlerts} alertPosition={alertPosition}>
										<Container horizontalAlign={'flex-end'} stretchContent>
											<Text textAlign={TextAlignment.end}>
												<CTAStyled className="cta-styled" alertType={alertType}>
													<CTA tag="button" emphasis={'nbab'} icon={<Add variant="default" aria-hidden />} />
												</CTAStyled>
											</Text>
										</Container>
									</CTAContainer>
								)}
							</>
						)}
					</CardContainer>
				</>
			)}
		</>
	);
};
